<template>
    <section class="card-section">
        <div class="section-title">
            <h2>Finalização / relatório</h2>
            <span>Disposição, panorama sanitário, classificação e assinaturas</span>
        </div>

        <div class="alert-box">
            <strong>Disposição:</strong>
            <textarea v-model="localModel.disposicao" rows="3" />
        </div>

        <div class="summary-grid">
            <div class="summary-card">
                <span>Total de itens</span>
                <strong>{{ totais.totalItens }}</strong>
            </div>

            <div class="summary-card">
                <span>Conformes (C)</span>
                <strong>{{ totais.conforme }}</strong>
            </div>

            <div class="summary-card">
                <span>Conforme com restrição (CR)</span>
                <strong>{{ totais.conformeRestricao }}</strong>
            </div>

            <div class="summary-card">
                <span>Não conforme (NC)</span>
                <strong>{{ totais.naoConforme }}</strong>
            </div>

            <div class="summary-card">
                <span>Não avaliado / não se aplica (NA)</span>
                <strong>{{ totais.naoAplicavel }}</strong>
            </div>

            <div class="summary-card highlight">
                <span>% de conformidade</span>
                <strong>{{ totais.percentualConformidade }}%</strong>
            </div>
        </div>

        <div class="form-grid cols-4">
            <div class="form-item">
                <label>Total NA informado</label>
                <input v-model.number="localModel.totalNAInformado" type="number">
            </div>

            <div class="form-item">
                <label>Itens utilizáveis</label>
                <input :value="totais.itensUtilizaveis" type="number" readonly>
            </div>

            <div class="form-item">
                <label>Total conformes informado</label>
                <input v-model.number="localModel.totalConformesInformado" type="number">
            </div>

            <div class="form-item">
                <label>% conformidade informado</label>
                <input v-model.number="localModel.percentualConformidadeInformado" type="number" step="0.01">
            </div>
        </div>

        <div class="form-grid cols-3 mt-16">
            <div class="form-item">
                <label>Grupo de classificação</label>
                <select v-model="localModel.grupoClassificacao">
                    <option value="">Selecione</option>
                    <option value="GRUPO 01">Grupo 01 - 85 a 100%</option>
                    <option value="GRUPO 02">Grupo 02 - 61 a 84,99%</option>
                    <option value="GRUPO 03">Grupo 03 - 0 a 60,99%</option>
                </select>
            </div>

            <div class="form-item col-2">
                <label>Grupo sugerido pelo cálculo</label>
                <input :value="totais.grupo" type="text" readonly>
            </div>
        </div>

        <div class="form-item mt-16">
            <label>Conclusão fiscal / relatório final</label>
            <textarea v-model="localModel.conclusaoFiscal" rows="5" />
        </div>

        <div class="section-subtitle">Responsáveis pela inspeção</div>

        <div class="form-grid cols-3">
            <div class="form-item">
                <label>Responsável 1</label>
                <input v-model="localModel.nomeResponsavelInspecao1" type="text">
            </div>

            <div class="form-item">
                <label>Matrícula 1</label>
                <input v-model="localModel.matriculaResponsavelInspecao1" type="text">
            </div>

            <div class="form-item">
                <label>Assinatura 1</label>
                <input v-model="localModel.assinaturaResponsavelInspecao1" type="text">
            </div>

            <div class="form-item">
                <label>Responsável 2</label>
                <input v-model="localModel.nomeResponsavelInspecao2" type="text">
            </div>

            <div class="form-item">
                <label>Matrícula 2</label>
                <input v-model="localModel.matriculaResponsavelInspecao2" type="text">
            </div>

            <div class="form-item">
                <label>Assinatura 2</label>
                <input v-model="localModel.assinaturaResponsavelInspecao2" type="text">
            </div>
        </div>

        <div class="section-subtitle">Empresa / testemunha / fechamento</div>

        <div class="form-grid cols-3">
            <div class="form-item">
                <label>Responsável pela empresa</label>
                <input v-model="localModel.nomeResponsavelEmpresa" type="text">
            </div>

            <div class="form-item">
                <label>Assinatura empresa</label>
                <input v-model="localModel.assinaturaResponsavelEmpresa" type="text">
            </div>

            <div class="form-item">
                <label>Testemunha</label>
                <input v-model="localModel.nomeTestemunha" type="text">
            </div>

            <div class="form-item">
                <label>Assinatura testemunha</label>
                <input v-model="localModel.assinaturaTestemunha" type="text">
            </div>

            <div class="form-item">
                <label>Cidade</label>
                <input v-model="localModel.cidadeAssinatura" type="text">
            </div>

            <div class="form-item">
                <label>Data</label>
                <input v-model="localModel.dataAssinatura" type="date">
            </div>
        </div>


        <div class="form-grid cols-4">
    <div class="form-item">
        <label>Total NA</label>
        <input :value="totais.naoAplicavel" type="number" readonly>
    </div>

    <div class="form-item">
        <label>Itens utilizáveis</label>
        <input :value="totais.itensUtilizaveis" type="number" readonly>
    </div>

    <div class="form-item">
        <label>Total conformes</label>
        <input :value="totais.conforme" type="number" readonly>
    </div>

    <div class="form-item">
        <label>% conformidade</label>
        <input :value="totais.percentualConformidade" type="number" readonly>
    </div>
</div>

<div class="form-grid cols-3 mt-16">
    <div class="form-item">
        <label>Grupo sugerido</label>
        <input :value="totais.grupo" type="text" readonly>
    </div>

    <div class="form-item col-2">
        <label>Conclusão fiscal / relatório final</label>
        <textarea v-model="localModel.conclusaoFiscal" rows="4" />
    </div>
</div>

    </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    totais: {
        type: Object,
        required: true,
    },
})

const emit = defineEmits(['update:modelValue'])

const localModel = computed({
    get: () => props.modelValue,
    set: value => emit('update:modelValue', value),
})
</script>

<style scoped>
.card-section {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 10px;
    padding: 16px;
}

.section-title h2 {
    margin: 0;
    font-size: 18px;
    color: #1f2937;
}

.section-title span {
    display: block;
    margin-top: 4px;
    color: #6b7280;
    font-size: 13px;
}

.alert-box {
    margin-top: 14px;
    background: #fff7ed;
    border: 1px solid #fed7aa;
    border-radius: 10px;
    padding: 12px;
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 12px;
    margin-top: 16px;
}

.summary-card {
    border: 1px solid #dbe2ea;
    border-radius: 10px;
    padding: 12px;
    background: #f8fafc;
}

.summary-card span {
    display: block;
    font-size: 12px;
    color: #64748b;
    margin-bottom: 6px;
}

.summary-card strong {
    font-size: 20px;
    color: #0f172a;
}

.summary-card.highlight {
    background: #ecfeff;
    border-color: #a5f3fc;
}

.form-grid {
    display: grid;
    gap: 12px;
}

.cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.col-2 {
    grid-column: span 2;
}

.form-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-item label {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
}

.form-item input,
.form-item select,
.form-item textarea {
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 8px 10px;
    outline: none;
}

.section-subtitle {
    margin: 18px 0 10px;
    font-weight: 700;
    color: #334155;
}

.mt-16 {
    margin-top: 16px;
}

@media (max-width: 1100px) {
    .summary-grid,
    .cols-3,
    .cols-4 {
        grid-template-columns: 1fr;
    }

    .col-2 {
        grid-column: span 1;
    }
}
</style>